import React from 'react';
import { Form, Input, Col, Row, Modal, Select } from 'antd';
import Button from '../../../shared/globalStyling/Button';

export default function CreateAudienceForm({
  attributionAudienceName,
  closeForm,
  isFormOpen,
  onChangeStateValue,
  submitForm,
  showClassificationSelect,
  onClassificationChange,
  isClassificationGroup,
}) {
  const [form] = Form.useForm();

  return (
    <Modal
      title={(showClassificationSelect || isClassificationGroup) ? 'Create Classification Group' : 'Create Audience'}
      visible={isFormOpen}
      centered
      footer={null}
      onCancel={() => {
        closeForm(false);
        form.resetFields();
      }}
    >
      <Form layout="vertical" onFinish={submitForm} form={form}>
        <Row type="flex" justify="space-around">
          <Col span={24}>
            <Form.Item label="Name" name="name" rules={[{ required: true }]}>
              <Input
                placeholder={(showClassificationSelect || isClassificationGroup) ? 'Name of Classification Group' : 'Name of Audience'}
                name="name"
                value={attributionAudienceName}
                onChange={(e) => {
                  onChangeStateValue('attributionAudienceName', e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {showClassificationSelect && (
          <Row type="flex" justify="space-around">
            <Col span={24}>
              <Form.Item
                label="Classification Type"
                name="classificationType"
                rules={[{ required: true, message: 'Please select a classification type' }]}
              >
                <Select
                  placeholder="Select Classification Type"
                  onChange={(value) => {
                    if (onClassificationChange) {
                      onClassificationChange(value);
                    }
                  }}
                >
                  <Select.Option value="COMPLIANCE_MEDICAL">Medical</Select.Option>
                  <Select.Option value="COMPLIANCE_RECREATIONAL">Recreational</Select.Option>
                  <Select.Option value="COMPLIANCE_BOTH">Both</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row type="flex" justify="space-around" align="middle">
          <Col span={24}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button htmlType="submit" type="primary">
                Create
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
